import httpAuth from '@/services/httpAuth'

import { serialize } from '@/services/object'

export async function list (filtros, all = false) {
  return httpAuth.get(`/admin/interacoes?${serialize({ ...filtros, all })}`, {
    tela: 'interacoes'
  })
}

export async function add (funcionalidade, dados) {
  return httpAuth.post('/admin/interacoes', dados, { funcionalidade: funcionalidade })
}

export async function edit (funcionalidade, id, dados) {
  return httpAuth.put(`/admin/interacoes/${id}`, dados, { funcionalidade: funcionalidade })
}

export async function del (funcionalidade, id) {
  return httpAuth.delete(`/admin/interacoes/${id}`, { funcionalidade: funcionalidade })
}
